<template>
    <div>
        <el-dialog :visible="createShow" title="提币/充币提醒信息设置" width="1000px" @close="closeDialog">
            <el-select v-model="optionType">
                <el-option value="1" label="提币"></el-option>
                <el-option value="2" label="充币"></el-option>
            </el-select>
            <el-form :model="saveInfo" ref="createForm" :rules="rules" class="news-form">
                <el-form-item label="币种" prop="coinType">
                    <el-input v-model="saveInfo.coinType"/>
                </el-form-item>
                <el-form-item label="链类型" prop="chainType">
                    <el-input v-model="saveInfo.chainType"/>
                </el-form-item>
                <el-form-item label="中文内容" prop="contentZh">
                    <el-input v-model="saveInfo.contentZh"/>
                </el-form-item>
                <el-form-item label="英文内容" prop="contentEn">
                    <el-input v-model="saveInfo.contentEn"/>
                </el-form-item>
                <el-form-item label="韩文内容" prop="contentKr">
                    <el-input v-model="saveInfo.contentKr"/>
                </el-form-item>
                <el-form-item label="越南语内容" prop="contentVi">
                    <el-input v-model="saveInfo.contentVi"/>
                </el-form-item>
            </el-form>
            <el-button @click="closeDialog">取消</el-button>
            <el-button type="primary" @click="handleSave('createForm')">保存</el-button>
        </el-dialog>
    </div>
</template>

<script>
    import {mapActions} from 'vuex';

    export default {
        name: "createRemind",
        props: ['createShow'],
        data() {
            return {
                optionType: '1',
                saveInfo: {
                    coinType: '',
                    contentZh: '',
                    contentEn: '',
                    contentKr: '',
                    contentVi: '',
                    chainType: '',
                    optionType: '',
                },
                rules: {
                    contentZh: [{required: true, message: '中文内容不能为空！'}],
                    contentEn: [{required: true, message: '英文内容不能为空！'}],
                    coinType: [{required: true, message: '币种不能为空！'}],
                    contentKr: [{required: true, message: '韩文内容不能为空！'}],
                    contentVi: [{required: true, message: '越南语内容不能为空！'}]
                }
            }
        },
        methods: {
            ...mapActions('coinRemindSetting', ['addCoinRemind']),
            closeDialog() {
                this.$refs['createForm'].resetFields();
                this.$emit('refresh');
            },
            handleSave(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        if (this.optionType == 2) {
                            this.saveInfo.optionType = 'recharge';
                        } else {
                            this.saveInfo.optionType = 'extract';
                        }
                        this.addCoinRemind(this.saveInfo).then(() => {
                            this.$message({type: 'success', message: '新增成功'})
                            this.closeDialog();
                        })

                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>
